import React, { useEffect, useState } from "react";
import { useForm, FormContext } from "react-hook-form";
import * as yup from "yup";

import Dropzone from "../Dropzone";
import Error from "../Error";
import { useFirestoreConnect, isLoaded } from "react-redux-firebase";
import { useSelector, connect } from "react-redux";
import LoadingIndicator from "../../common/LoadingIndicator";
import { updateSaleBanners } from "../../../store/actions/RestaurantActions";

const FILE_SIZE = 300000;
const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "image/jpg"];

const schema = yup.object().shape({
  salePromotions: yup
    .mixed()
    .test("fileLength", "Debes seleccionar al menos un archivo", (files) => {
      if (!files || files.length === 0) return false;

      return true;
    })
    .test("fileSize", "Alguno de los archivos es muy grande", (files) => {
      if (!files || files.length === 0) return false;

      let valid = true;
      files.some((file) => {
        if (file.size >= FILE_SIZE) {
          valid = false;
        }
      });

      return valid;
    })
    .test(
      "fileType",
      "El tipo de uno de los archivos no es soportado",
      (files) => {
        if (!files || files.length === 0) return false;

        let valid = true;

        files.some((file) => {
          if (typeof file === "string") return;

          if (!SUPPORTED_FORMATS.includes(file.type)) {
            valid = false;
          }
        });

        return valid;
      }
    ),
});

const SalePromotionsForm = ({ updateSaleBanners }) => {
  const [deletedFiles, setDeletedFiles] = useState([]);

  useFirestoreConnect([
    {
      collection: "carousel",
    },
  ]);

  const salePromotions = useSelector(
    ({ firestore }) => firestore.ordered.carousel
  );

  const {
    register,
    handleSubmit,
    errors,
    reset,
    setValue,
    getValues,
    unregister,
    triggerValidation,
    watch,
  } = useForm({
    validationSchema: schema,
    defaultValues: {
      salePromotions: salePromotions && salePromotions.map((s) => s.image),
    },
  });

  useEffect(() => {
    if (salePromotions) {
      reset({ salePromotions: salePromotions.map((s) => s.image) });
      register("salePromotions");
    }
  }, [salePromotions]);

  const changePromotions = (values) => {
    updateSaleBanners(values.salePromotions, deletedFiles);
  };

  if (!isLoaded(salePromotions)) return <LoadingIndicator></LoadingIndicator>;

  return (
    <form onSubmit={handleSubmit(changePromotions)} className="">
      <FormContext
        {...{ register, unregister, setValue, triggerValidation, watch, reset }}
      >
        <Dropzone
          label="Archivos adjuntos"
          name="salePromotions"
          accept={SUPPORTED_FORMATS}
          multiple
          selectedFiles={salePromotions.map((obj) => obj.image)}
          setDeletedFiles={setDeletedFiles}
          deletedFiles={deletedFiles}
        ></Dropzone>
      </FormContext>
      <div className="flex">
        <Error error={errors.salePromotions} leftleft></Error>
      </div>
      <div className="flex justify-start mt-6">
        <button className="block bg-brand-300 rounded-md text-brand-800 py-2 px-4 text-sm font-bold border-2 border-brand-700">
          Actualizar carrusel
        </button>
      </div>
    </form>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSaleBanners: (files, deletedFiles) =>
      dispatch(updateSaleBanners(files, deletedFiles)),
  };
};
export default connect(null, mapDispatchToProps)(SalePromotionsForm);
